import { FormControl } from "@angular/forms";

export function noWhitespaceValidator(control: FormControl) {
  const isWhitespace = (control.value || "").trim().length === 0;
  const isValid = !isWhitespace;
  return isValid ? null : { whitespace: true };
}
